module.exports = __webpack_public_path__ + "img/icon_search.49dbec0a.svg";